<template>
  <v-dialog v-model="dialog" width="338" persistent>

    <template v-slot:activator="{ on, attrs }">
      <v-text-field :label="label" v-model="dateTime" read-only dense hide-details outlined v-bind="attrs" v-on="on" :disabled="disabled" :loading="loading">
        <v-icon slot="append" color="error" v-if="dateTime!==null" @click="clearDatetime">close</v-icon>
      </v-text-field>
    </template>

    <v-card>
      <v-card-text>

        <v-tabs v-model="tab" fixed-tabs>
          <v-tabs-slider color="primary"></v-tabs-slider>
          <v-tab key="date"><v-icon>{{dateIcon}}</v-icon></v-tab>
          <v-tab key="time"><v-icon>{{timeIcon}}</v-icon></v-tab>
        </v-tabs>

        <v-row>
          <v-col class="mt-5 py-0">
            <p class="text-center title mb-0">{{dateTime}}</p>
          </v-col>
        </v-row>

        <v-tabs-items v-model="tab">
          <v-tab-item key="date">
            <v-row>
              <v-col>
                <v-date-picker v-model="dateSelected" :min="getMinDate" @input="showTimePicker" no-title></v-date-picker>
              </v-col>
            </v-row>
          </v-tab-item>

          <v-tab-item key="time">
            <v-row>
              <v-col>
                <v-time-picker ref="timer" v-model="timeSelected" format="24hr" no-title></v-time-picker>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>

      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn color="warning" small outlined @click="clearDatetime" :disabled="dateTime===null">CLEAR</v-btn>

        <v-spacer></v-spacer>

        <v-btn color="primary" small @click="setDatetime" :disabled="dateTime===null">SET</v-btn>
        <v-btn color="primary" small outlined @click="cancelDatetime">CANCEL</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mdiCalendar,mdiClockOutline } from '@mdi/js';
  import moment from 'moment';

  export default {
    props: ['label','pdt','disabled','loading', 'dateToday'],

    data() {
      return {
        dialog: false,
        dialogOpened: false,
        tab: 0,
        dateIcon: mdiCalendar,
        timeIcon: mdiClockOutline,
        initialDateTime: '',
        dateSelected: '',
        timeSelected: '',
      }
    },

    computed: {
      dateTime() {
        if((this.pdt!==null&&this.pdt!=='')&&this.initialDateTime===''){
          this.dateSelected = moment(new Date(this.pdt)).format('yyyy-MM-DD');
          this.timeSelected = moment(new Date(this.pdt)).format('HH:mm');
        }
        if(this.dateSelected!==''&&this.timeSelected!==''){
          return `${this.dateSelected} ${this.timeSelected}`;
        }
        return null;
      },

      getMinDate() {
        if(this.dateToday) return this.dateToday;
        return null;
      }
    },

    watch: {
      dialog(val) {
        if(val){
          this.tab = 0;
          if(this.pdt!==null&&this.pdt!==''){
            this.initialDateTime = this.pdt;
          }
        }
      }
    },

    methods: {
      showTimePicker() {
        if(this.$refs.timer){
          this.$refs.timer.selectingHour = true
        }
        this.tab = 1;
      },

      setDatetime(){
        this.$emit('set-datetime',this.dateTime);
        this.dialog = false;
      },

      cancelDatetime(){
        if(this.initialDateTime!==''&&this.initialDateTime!==null){
          this.dateSelected = moment(new Date(this.initialDateTime)).format('yyyy-MM-DD');
          this.timeSelected = moment(new Date(this.initialDateTime)).format('HH:mm');
        }
        this.dialog = false;
      },
      
      clearDatetime(){
        this.dateSelected = '';
        this.timeSelected = '';
        this.$emit('set-datetime',null);
        this.dialog = false;
      },

      resetDateTimePicker() {
        this.dateSelected = '';
        this.timeSelected = '';
        this.initialDateTime = '';
      }
    },
  }
</script>

<style lang="scss" scoped></style>
